<template>
    <div class="employee-block" v-if="visible && postData">
        <h5>{{postData.title.rendered}}</h5>
        <p class="position" v-html="postData.acf.info.position"></p>
        <p><a :href="'mailto:'+postData.acf.info.email">{{postData.acf.info.email}}</a></p>
        <p><a :href="'tel:'+postData.acf.info.phone">{{postData.acf.info.phone}}</a></p>
    </div>
    <postBlockLoader v-observe-visibility="{
        callback: checkVisibility,
        intersection: {
            rootMargin: '100px 0px 0px 0px',
            threshold: 0
        }
        }" v-else />
</template>

<script>

import postBlockLoader from '@/components/loaders/postBlock'

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'employee-block',
    props: ['id', 'type'],
    components: {
        postBlockLoader
    },
    data(){
        return{
            visible: false,
            loading: false
        }
    },
    computed: {
        ...mapGetters([
            'getPostById'
        ]),
        postData(){
            const postType = this.type || 'employees'
            const postId = this.id
            
            let post = this.getPostById( postId )
            if(!post && !this.loading){
                this.loading = true
                this.loadPostById({ id: postId, postType } )
            }
            return post
        }
    },
    methods: {
        ...mapActions([
            'loadPostById'
        ]),
        checkVisibility(vis, el){
            if(vis && !this.visible) {
                this.visible = true
            }
        }
    },
}
</script>